import React, { useMemo, useRef, useState } from 'react';
import { useSelector } from 'umi';
import Filter from '@/pages/dashboard/components/NewFilter';
import { parseUrlInfo, setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { findPageSelector } from '../../components/NewFilter/util';
import { getDateDefault } from '../../utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const firstWordUpper = (str: string) => {
  if (!str) return str;

  const firstLetter = str.charAt(0);

  const firstLetterCap = firstLetter.toUpperCase();

  const remainingLetters = str.slice(1);

  return firstLetterCap + remainingLetters;
};

const ChurnAllFilter = (props: any) => {
  const { filterConfirm, filterReset, setFilterLoading, filterInit, openSticky = false, children, isHaveFilterSave, path, timeZone = 0 } = props;
  // daily筛选器继承逻辑
  const filterValueRef = useRef<any>({
    rangeTime: {
      type: 'week',
      value: getDateDefault({timeType: 'week', timeZone, startNum: 6, endNum: 1}),
    },
  });
  // const { defaultExtendsKeyList, getPageLockDefaultValue } = useLockValue({
  //     supportTimeTypeList: ['week','month'],
  //     timePickerType: 'range',
  //   })
  // const extendsFormValue = getPageLockDefaultValue(defaultValue, defaultExtendsKeyList)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {seasonInfo, dataFrame, gameConfig} = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { week: [],month: [] },
      dataFrame: state.dashboard?.currentGame?.data_frame || 'mobile',
      gameConfig: state.dashboardSetting.gameConfig,
    })
  );
  // 获取selector
  const selectorList = useMemo(() => {
    const { default_selector: defaultSelector = [], page_selector: pageSelector = [] } = gameConfig || {};
    // 优先取筛选器的path
    let realPath = path;
    if (!realPath) {
      const pathInfo = parseUrlInfo(location.pathname);
      realPath = pathInfo.realPath;
    }
    const result = findPageSelector(realPath, pageSelector, defaultSelector, dataFrame);
    return result;
  }, [gameConfig, path, dataFrame]);

  // 设置inputList
  const [inputList] = useState([
    {
      type: 'rangeDate',
      key: 'rangeTime',
      default: {
        type: 'week',
        value: getDateDefault({timeType: 'week', timeZone, startNum: 6, endNum: 1}),
      },
      componentDefault: {
        week: getDateDefault({timeType: 'week', timeZone, startNum: 6, endNum: 1}),
        month: getDateDefault({timeType: 'month', timeZone, startNum: 6, endNum: 1}),
      },
      typeList: ['week', 'month'],
      extraShortcut: seasonInfo
    },
  ]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    const filterValue = {
      ...value,
      timeType: firstWordUpper(value?.rangeTime?.type),
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      filterDefaultSelect: selectorList,
      pagePath: path
    };
    filterConfirm?.(filterValue);

    setBtnPointLog({
      confirmButtonId: '200901001',
      pageId: '200901'
    }, {
      ...value,
      timeType: firstWordUpper(value?.rangeTime?.type),
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
    });
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    const filterValue = {
      ...value,
      timeType: firstWordUpper(value?.rangeTime?.type),
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      filterDefaultSelect: selectorList,
      pagePath: path
    };
    filterReset?.(filterValue);

    setBtnPointLog({
      resetButtonId: '200901002',
      pageId: '200901'
    }, {
      ...value,
      timeType: firstWordUpper(value?.rangeTime?.type),
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
    }, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    filterInit?.({
      ...value,
      timeType: firstWordUpper(value?.rangeTime?.type),
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      filterDefaultSelect: selectorList,
      pagePath: path
    });
    setFilterLoading(false);
  };

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={path}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default ChurnAllFilter;
